import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "src/app/core/services/dialog.service";

@Component({
  selector: "app-yes-no-dialog",
  templateUrl: "./yes-no-dialog.component.html",
  styleUrls: ["./yes-no-dialog.component.scss"]
})
export class YesNoDialogComponent {

  constructor(public dialogService: DialogService,
    public router: Router) {
  }

  onYes() {
    this.dialogService.confirmYes();
    this.dialogService.closeDialog();
  }

  goBack() {
    this.dialogService.cancelNo();
    this.dialogService.closeDialog();
  }
}
